import { Box, Skeleton } from '@chakra-ui/react';
import * as QuickSightEmbedding from 'amazon-quicksight-embedding-sdk';
import React, { useEffect, useState } from 'react';

import type { EmbedStylingInput } from '../types';
import { InfoChangeEventName } from 'amazon-quicksight-embedding-sdk/dist/enums';

type QuickSightEmbedDashboardInput = {
  quickSightUrl: string;
  containerId: string;
  embedStyling?: EmbedStylingInput;
};
export const QuickSightEmbedDashboard = ({
  quickSightUrl,
  containerId,
  embedStyling,
}: QuickSightEmbedDashboardInput) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    let mounted = true;

    const getContextAndEmbedDashboard = async () => {
      const quickSightContainer = document.getElementById(containerId);
      if (!quickSightContainer) {
        return;
      }

      const context = await QuickSightEmbedding.createEmbeddingContext({
        onChange: ({ eventName }) => {
          if (eventName === InfoChangeEventName.FRAME_LOADED) {
            if (mounted) {
              setIsLoading(false);
            }
          }
        },
      });

      const frameOptions: QuickSightEmbedding.QSE.FrameOptions = {
        url: quickSightUrl,
        container: quickSightContainer,
        resizeHeightOnSizeChangedEvent:
          embedStyling?.resizeHeightOnSizeChangedEvent,
        height: embedStyling?.height ?? '600',
      };

      if (mounted) {
        await context.embedDashboard(frameOptions, { locale: 'en-US' });
      }
    };

    getContextAndEmbedDashboard();

    return () => {
      mounted = false;
    };
  }, [containerId, embedStyling, quickSightUrl]);

  return (
    <Box id={containerId} height="fit-content">
      {isLoading && (
        <Skeleton
          height="600px"
          data-testid="quicksight-dashboard-loading-skeleton"
          isLoaded={false}
        />
      )}
    </Box>
  );
};
